import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import Podcasts from '@/components/screens/podcasts/Podcasts';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IPodcastsPage } from '@/interfaces/podcastsPage.interface';

const AudioBooksPage: NextPage<IPodcastsPage> = ({ books }) => {
  return <Podcasts books={books} sortingName="по рейтингу" />;
};

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch(`${API_URL}satellite/podcast/podcast?page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=rating&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default AudioBooksPage;
